import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { trackPageView, setUserType } from '../utils/analytics';
import { updateUserTypeSummary } from '../services/visitorService';

const ADMIN_EMAILS = ['info@tronapazarlama.com'];

export const useVisitorTracking = () => {
  const location = useLocation();
  const trackingInitialized = useRef(false);
  const isAdminUser = useRef(false);

  // ✅ İlk yükleme - Auth state listener
  useEffect(() => {
    console.log('🎯 AUTH LISTENER KURULMAYA BAŞLANDI...');

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      // ✅ Tracking zaten yapıldıysa tekrar yapma
      if (trackingInitialized.current) {
        console.log('⚠️ Tracking zaten yapılmış, atlanıyor');
        return;
      }

      console.log('═══════════════════════════════════');
      console.log('🚀 ANALYTICS TRACKING BAŞLADI');
      console.log('👤 User:', user?.email || 'GUEST');
      console.log('📍 Path:', window.location.pathname);
      console.log('⏰ Timestamp:', new Date().toISOString());

      // Admin kontrolü
      const isAdmin = user?.email && ADMIN_EMAILS.includes(user.email.toLowerCase());
      isAdminUser.current = isAdmin;

      console.log('🔍 Admin Check:', {
        email: user?.email,
        isAdmin: isAdmin,
        adminList: ADMIN_EMAILS
      });

      if (isAdmin) {
        console.log('🔒 ═══ ADMIN TESPİT EDİLDİ ═══');
        console.log('🔒 Tracking devre dışı');
        console.log('🔒 Analytics başlatılmayacak');
        console.log('🔒 Firestore\'a kayıt yapılmayacak');
        console.log('═══════════════════════════════════');
        trackingInitialized.current = true;
        return;
      }

      console.log('✅ Normal kullanıcı - Tracking başlıyor...');

      // 1 saniye bekle - Analytics'in kesin başlaması için
      await new Promise(resolve => setTimeout(resolve, 1000));

      try {
        // ✅ Analytics'e user type gönder
        console.log('📤 setUserType çağrılıyor...');
        await setUserType(user);

        // ✅ İlk page view gönder
        console.log('📤 trackPageView çağrılıyor...');
        await trackPageView(window.location.pathname);

        // ✅ Firestore'a kaydet
        const userType = user ? 'registered' : 'guest';
        console.log('📤 updateUserTypeSummary çağrılıyor...', { userType, email: user?.email });
        const result = await updateUserTypeSummary(userType, user?.email);
        
        if (result.skipped) {
          console.log('⚠️ Firestore kaydı atlandı (Admin)');
        } else if (result.success) {
          console.log('💾 Firestore kaydedildi:', userType);
        } else {
          console.error('❌ Firestore kayıt hatası:', result.error);
        }

        console.log('✅ Tracking tamamlandı');
      } catch (error) {
        console.error('❌ Tracking hatası:', error);
      }

      console.log('═══════════════════════════════════');
      trackingInitialized.current = true;
    });

    // ✅ Cleanup - Component unmount olduğunda
    return () => {
      console.log('🧹 useVisitorTracking cleanup - Auth listener kaldırılıyor');
      unsubscribe();
    };
  }, []); // ✅ Boş dependency - Sadece mount'ta çalışsın

  // ✅ Sayfa değişimleri
  useEffect(() => {
    // İlk tracking tamamlanana kadar bekle
    if (!trackingInitialized.current) {
      console.log('⏳ Tracking henüz initialize olmadı, sayfa tracking atlanıyor');
      return;
    }

    // ✅ Admin ise sayfa değişimlerini de takip etme
    if (isAdminUser.current) {
      console.log('🔒 ADMIN - Sayfa tracking atlandı:', location.pathname);
      return;
    }

    console.log('📄 Sayfa değişti:', location.pathname);
    trackPageView(location.pathname);
  }, [location.pathname]);
};